export function truncateText(text: string, size: number = 30): string {
  const textToTruncat = text ?? "";
  if (textToTruncat.length <= size) {
    return textToTruncat;
  }
  return textToTruncat.substring(0, size) + "...";
}

// Fonction pour vérifier si une valeur est une chaîne de caractères
export const isString = (value: unknown): value is string => {
  return typeof value === "string";
};
